var MPI_ROUTES = [
    'PAR-ALG',
    'PAR-DKR',
    'PAR-PTP',
    'PAR-DXB',
    'PAR-FDF',
    'PAR-HKT',
    'PAR-BKO',
    'PAR-TYO',
    'PAR-ABJ',
    'PAR-DPS',
    'PAR-CMB',
    'PAR-CAI',
    'PAR-DEL',
    'PAR-BJA',
    'PAR-PNH',
    'PAR-SGN',
    'PAR-HAN',
    'PAR-KTM',
    'PAR-TLM',
    'PAR-MNL',
    'PAR-DLA',
    'PAR-NOU',
    'PAR-MRS',
    'ALG-PAR',
    'DKR-PAR',
    'PTP-PAR',
    'DXB-PAR',
    'FDF-PAR',
    'HKT-PAR',
    'BKO-PAR',
    'TYO-PAR',
    'ABJ-PAR',
    'DPS-PAR',
    'CMB-PAR',
    'CAI-PAR',
    'DEL-PAR',
    'BJA-PAR',
    'PNH-PAR',
    'SGN-PAR',
    'HAN-PAR',
    'KTM-PAR',
    'TLM-PAR',
    'MNL-PAR',
    'DLA-PAR',
    'NOU-PAR',
    'MRS-PAR',
];
module.exports = MPI_ROUTES;
